/**
 *
 * Button
 *
 */
import React from 'react';
import PropTypes from 'prop-types';

function SqzButton(props) {
  return (
    <button
      className={`btn btn--secondary home__btn giftBttn ${props.addClass}`}
      onClick={props.onClick}
      disabled={props.disabled}
      type={props.type}
    >
      {props.children}
      {props.addRightArrow && <i className="icon icon-btn-right" />}
    </button>
  );
}

SqzButton.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  addClass: PropTypes.string,
  addRightArrow: PropTypes.bool,
  type: PropTypes.string,
};

export default SqzButton;
